import Auth from "./auth";
import Http from "./axios.http";
import Repo from "@/util/repo/localstorage.repo";

let auth = new Auth(new Repo(), new Http(), process.env.VUE_APP_BASE_URL_API);

Object.freeze(auth);
export default auth;
